import BaseSurveyAPI from '../s-base'

class UserService extends BaseSurveyAPI {
  /**
   * 获取验证码接口
   */
  fetchCode(params) {
    return this.get({
      url: '/blade-auth/vcode/send-msg',
      params,
    })
  }

  /**
   * 获取租户
   */
  getUserTenants(phone, code) {
    return this.get({
      url: '/blade-system/tenant/select-by-phone',
      params: {
        phone,
        vcode: code,
      },
    })
  }

  /**
   * 切换租户获取phone/code
   */
  getUserTenantsByToken() {
    return this.get({
      url: '/blade-system/tenant/select-by-token',
    })
  }

  /**
   * 获取用户信息
   */
  getUserInfo() {
    return this.get({
      url: '/blade-user/info',
    })
  }

  updateUserInfo(row) {
    return this.post({
      url: '/blade-user/update',
      data: row,
    })
  }

  updatePassword(oldPassword, newPassword, newPassword1) {
    return this.post({
      url: '/blade-user/updUserInfo-password',
      params: {
        oldPassword,
        newPassword,
        newPassword1,
      },
    })
  }

  /**
   * 以手机号验证码和租户Id进行登录
   */
  login(data) {
    return this.post({
      url: '/blade-auth/oauth/token',
      params: data,
    })
  }

  saveLogo(uploadUri) {
    return this.post({
      url: '/vocust-desk/tenant/upload/saveLogo',
      data: { uploadUri },
    })
  }

  fetchTenantDetail() {
    return this.get({
      url: `/vocust-desk/tenant/detail`,
    })
  }

  changePassword(data) {
    return this.post({
      url: `/vocust-qms/user/modifyPassword`,
      data,
    })
  }

  /**
   * @description 是否是管理员
   * @returns Boolean
   */
  getIsManager() {
    return this.get({
      url: '/cem-4x/user/is-manager',
    })
  }
}

export default new UserService()
